import { createApi } from '@reduxjs/toolkit/query/react';
import {
    AuthUserConfirmationRequestIF,
    CheckCodeIF,
    ConfirmConfirmationIF,
    ConfirmRequestEmailCheckIF,
    CreateUserConfirmationEmailIF,
} from '@/api/authEmailApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const authEmailApi = createApi({
    reducerPath: 'confirmationApi',
    baseQuery: fetchRestApiQuery('/ConfirmationRequests'),
    endpoints: (builder) => ({
        createUserEmail: builder.mutation<void, CreateUserConfirmationEmailIF>({
            query: ({ email, confirmationGuid }) => ({
                url: '/User',
                method: 'POST',
                body: {
                    email,
                    confirmationGuid,
                },
            }),
        }),
        checkCode: builder.mutation<ConfirmRequestEmailCheckIF, CheckCodeIF>({
            query: ({ code, data, confirmationGuid }) => ({
                url: '/Email/CheckCode',
                method: 'POST',
                body: {
                    code,
                    data,
                    confirmationGuid,
                },
            }),
        }),
        confirmEmail: builder.mutation<void, ConfirmConfirmationIF>({
            query: ({ code, confirmationGuid }) => ({
                url: '/Email/Confirm',
                method: 'POST',
                body: {
                    code,
                    confirmationGuid,
                },
            }),
        }),
        authUser: builder.mutation<void, AuthUserConfirmationRequestIF>({
            query: ({ email, confirmationGuid }) => ({
                url: '/Auth',
                method: 'POST',
                body: {
                    email,
                    confirmationGuid,
                },
            }),
        }),
        recoveryEmail: builder.mutation<void, AuthUserConfirmationRequestIF>({
            query: ({ email, confirmationGuid }) => ({
                url: '/Recovery',
                method: 'POST',
                body: {
                    email,
                    confirmationGuid,
                },
            }),
        }),
    }),
});
